import { render, staticRenderFns } from "./ResposibleDeclaration.vue?vue&type=template&id=8f785a98&scoped=true&"
import script from "./ResposibleDeclaration.vue?vue&type=script&lang=js&"
export * from "./ResposibleDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./ResposibleDeclaration.vue?vue&type=style&index=0&id=8f785a98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f785a98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
